import { GpsMap } from "../models/gps-map";

export class SignalMappingHeader {
	parent: any;
	async bind(bindingContext: any, overrideContext: any) {
		this.parent = bindingContext;
	}
}